import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "destroy", "progress", "dropzone"]
  static values = { url: String }

  connect() {
    this.dragCounter = 0
    this.boundClearUpload = this.clearFromExternal.bind(this)
    this.element.addEventListener("media-picker:clear-upload", this.boundClearUpload)
  }

  disconnect() {
    this.element.removeEventListener("media-picker:clear-upload", this.boundClearUpload)
  }

  clearFromExternal() {
    this.clearPreview()
    if (this.hasHiddenTarget) this.hiddenTarget.value = ""
    if (this.hasInputTarget) this.inputTarget.value = ""
    if (this.hasDestroyTarget) this.destroyTarget.value = "1"
  }

  async upload(event) {
    const file = event.target.files[0]
    if (!file) return
    await this.uploadFile(file)
  }

  async uploadFile(file) {
    this.showPreview(file)
    this.progressTarget.hidden = false

    const formData = new FormData()
    formData.append("file", file)

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const response = await fetch(this.urlValue, {
      method: "POST",
      body: formData,
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {}
    })

    if (!response.ok) {
      this.progressTarget.textContent = "Upload failed"
      this.clearPreview()
      return
    }

    const data = await response.json()
    this.hiddenTarget.value = JSON.stringify(data)
    this.progressTarget.hidden = true
  }

  dragenter(event) {
    event.preventDefault()
    this.dragCounter++
    this.dropzoneTarget.classList.add("is-dragover")
  }

  dragover(event) {
    event.preventDefault()
  }

  dragleave(event) {
    event.preventDefault()
    this.dragCounter--
    if (this.dragCounter <= 0) {
      this.dragCounter = 0
      this.dropzoneTarget.classList.remove("is-dragover")
    }
  }

  async drop(event) {
    event.preventDefault()
    this.dragCounter = 0
    this.dropzoneTarget.classList.remove("is-dragover")
    const file = event.dataTransfer.files[0]
    if (!file || !file.type.startsWith("image/")) return
    const dt = new DataTransfer()
    dt.items.add(file)
    this.inputTarget.files = dt.files
    await this.uploadFile(file)
  }

  showPreview(file) {
    const objectUrl = URL.createObjectURL(file)
    let preview = this.dropzoneTarget.querySelector(".image-field__preview")
    if (!preview) {
      preview = document.createElement("img")
      preview.className = "image-field__preview"
      this.dropzoneTarget.prepend(preview)
    }
    preview.src = objectUrl
    this.dropzoneTarget.classList.add("has-preview")
  }

  clearPreview() {
    const preview = this.dropzoneTarget.querySelector(".image-field__preview")
    if (preview) preview.remove()
    this.dropzoneTarget.classList.remove("has-preview")
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()
    this.clearPreview()
    this.hiddenTarget.value = ""
    this.inputTarget.value = ""
    if (this.hasDestroyTarget) {
      this.destroyTarget.value = "1"
    }
  }
}
